import React from "react";

// Eyebrow + h2 + intro paragraph at the top of each landing section.
// `id` goes on the h2 so the section can reference it with aria-labelledby.
export default function LandingSectionHeading({ id, eyebrow, title, subtitle, align = "center" }) {
  const alignment = align === "center" ? "tw-mx-auto tw-text-center" : "tw-text-center lg:tw-text-left";

  return (
    <div className={`tw-max-w-3xl ${alignment}`}>
      {eyebrow && (
        <p className="tw-mb-3 tw-text-sm tw-font-bold tw-uppercase tw-tracking-[0.18em] tw-text-[#FF43A7]">
          {eyebrow}
        </p>
      )}
      <h2
        id={id}
        className="tw-m-0 tw-text-3xl tw-font-extrabold tw-leading-tight tw-tracking-tight tw-text-white [text-wrap:balance] md:tw-text-5xl"
      >
        {title}
      </h2>
      {subtitle && (
        <p className="tw-mb-0 tw-mt-4 tw-text-lg tw-leading-relaxed tw-text-white/70 md:tw-text-xl">
          {subtitle}
        </p>
      )}
    </div>
  );
}
